<template>
    <div class="reservation-details-content">
        <SectionContainer
            title="Informações da Reserva"
            icon="calendar-check"
        >
            <!-- Grid de cards informativos -->
            <div class="info-cards-grid">
                <div class="info-card">
                    <div class="card-icon">
                        <i class="fas fa-user"></i>
                    </div>
                    <div class="card-content">
                        <div class="card-label">Usuário:</div>
                        <div class="card-value">{{ reserve.user ? reserve.user.name : 'N/A' }}</div>
                    </div>
                </div>

                <div class="info-card" v-if="reserve.driver">
                    <div class="card-icon">
                        <i class="fas fa-user"></i>
                    </div>
                    <div class="card-content">
                        <div class="card-label">Motorista:</div>
                        <div class="card-value">{{ reserve.driver ? reserve.driver.name : 'N/A' }}</div>
                    </div>
                </div>

                <div class="info-card">
                    <div class="card-icon">
                        <i class="fas fa-map-marker-alt"></i>
                    </div>
                    <div class="card-content">
                        <div class="card-label">Cidade Destino:</div>
                        <div class="card-value">
                            {{
                                reserve.city_destination && reserve.city_destination.city_destination
                                    ? reserve.city_destination.city_destination.description
                                    : 'N/A'
                            }}
                        </div>
                    </div>
                </div>

                <div class="info-card">
                    <div class="card-icon">
                        <i class="fas fa-calendar-alt"></i>
                    </div>
                    <div class="card-content">
                        <div class="card-label">Data de Retirada:</div>
                        <div class="card-value date-highlight">{{ reserve.retreat_date || 'N/A' }}</div>
                    </div>
                </div>

                <div class="info-card">
                    <div class="card-icon">
                        <i class="fas fa-calendar-times"></i>
                    </div>
                    <div class="card-content">
                        <div class="card-label">Data de Devolução:</div>
                        <div class="card-value date-highlight">{{ reserve.devolution_date || 'N/A' }}</div>
                    </div>
                </div>

                <div class="info-card">
                    <div class="card-icon">
                        <i class="fas fa-building"></i>
                    </div>
                    <div class="card-content">
                        <div class="card-label">Filial:</div>
                        <div class="card-value">{{ reserve.branch ? reserve.branch.description : 'N/A' }}</div>
                    </div>
                </div>

                <div class="info-card">
                    <div class="card-icon">
                        <i class="fas fa-info-circle"></i>
                    </div>
                    <div class="card-content">
                        <div class="card-label">Status:</div>
                        <div class="card-value">
                            <span
                                class="status-badge-small"
                                :class="getStatusClass(reserve.reserve_status)"
                            >
                                {{ reserve.reserve_status ? reserve.reserve_status.title : 'N/A' }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Seção de textos longos -->
            <div class="text-sections mt-4">
                <div class="row">
                    <div
                        class="col-md-6"
                        v-if="reserve.justification"
                    >
                        <div class="text-section">
                            <div class="section-header-reserve">
                                <i class="fas fa-clipboard-list"></i>
                                <span>Justificativa</span>
                            </div>
                            <div class="section-content">
                                {{ reserve.justification.description || 'Não informado' }}
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="text-section">
                            <div class="section-header-reserve">
                                <i class="fas fa-comment-alt"></i>
                                <span>Motivo da Reserva</span>
                            </div>
                            <div class="section-content">
                                {{ reserve.reason || 'Não informado' }}
                            </div>
                        </div>
                    </div>

                    <div class="col-12 mt-4" v-if="reserve.manager_observation">
                        <div class="text-section">
                            <div class="section-header-reserve">
                                <i class="fas fa-clipboard-list"></i>
                                <span>Observações do Gestor</span>
                            </div>
                            <div class="section-content">
                                {{ reserve.manager_observation || 'Não informado' }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Card de Passageiros -->
            <div class="passengers-section mt-4" v-if="reserve.rideList && reserve.rideList.length > 0">
                <SectionContainer
                    title="Passageiros da Viagem"
                    icon="users"
                >
                    <div class="passengers-grid">
                        <div
                            class="passenger-card"
                            v-for="(passenger, index) in reserve.rideList"
                            :key="passenger.id"
                        >
                            <div class="passenger-number">
                                {{ index + 1 }}
                            </div>
                            <div class="passenger-info">
                                <div class="passenger-name">
                                    <i class="fas fa-user mr-2"></i>
                                    {{ passenger.requester ? passenger.requester.name : 'Nome não disponível' }}
                                </div>
                                <div class="passenger-status">
                                    <span
                                        class="ride-status-badge"
                                        :class="getRideStatusClass(passenger.status)"
                                    >
                                        {{ getRideStatusText(passenger.status) }}
                                    </span>
                                </div>
                                <div class="passenger-date" v-if="passenger.departure_date">
                                    <i class="fas fa-calendar-alt mr-1"></i>
                                    {{ formatDate(passenger.departure_date) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </SectionContainer>
            </div>

            <!-- Ações de Check-List -->
            <div
                class="checklist-actions mt-4"
                v-if="reserve.reserve_status && (reserve.reserve_status.id == 4 || reserve.reserve_status.id == 5)"
            >
                <SectionContainer
                    title="Check-List do Veículo"
                    icon="clipboard-check"
                >
                    <div class="action-buttons">
                        <button
                            class="btn btn-primary"
                            @click="$emit('open-checklist')"
                        >
                            <i class="fas fa-clipboard-check mr-2"></i>
                            Visualizar Check-List
                        </button>
                    </div>
                </SectionContainer>
            </div>
        </SectionContainer>
    </div>
</template>

<script>
import SectionContainer from "../../Modals/Checklist/SectionContainer.vue";

export default {
    components: {
        SectionContainer
    },
    props: {
        reserve: { // reserve - dados da reserva
            type: Object,
            required: true
        }
    },
    methods: {
        getStatusClass(status) { // getStatusClass - retorna classe CSS baseada no status
            if (!status) return 'status-unknown';

            const statusClasses = {
                1: 'status-pending', // Pré-reserva
                2: 'status-approved', // Reservado
                3: 'status-canceled', // Cancelado
                4: 'status-progress', // Retirado
                5: 'status-completed' // Devolvido
            };
            return statusClasses[status.id] || 'status-unknown';
        },
        getRideStatusClass(status) { // getRideStatusClass - retorna classe CSS para status da carona
            const statusClasses = {
                1: 'ride-pending',
                2: 'ride-confirmed',
                3: 'ride-rejected'
            };
            return statusClasses[status] || 'ride-unknown';
        },
        getRideStatusText(status) { // getRideStatusText - retorna texto do status da carona
            const statusTexts = {
                1: 'Pendente',
                2: 'Confirmado',
                3: 'Rejeitado'
            };
            return statusTexts[status] || 'Desconhecido';
        },
        formatDate(dateString) { // formatDate - formata data para exibição
            if (!dateString) return '';
            try {
                const date = new Date(dateString);
                return date.toLocaleDateString('pt-BR') + ' ' + date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
            } catch (e) {
                return dateString;
            }
        }
    }
};
</script>

<style scoped>
.reservation-details-content {
    padding: 20px;
    background-color: white;
}

/* Grid de cards informativos */
.info-cards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 15px;
    margin-bottom: 20px;
}

.info-card {
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 16px;
    border-left: 4px solid #f8981d;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: center;
    gap: 15px;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.info-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.card-icon {
    width: 40px;
    height: 40px;
    background-color: #f8981d;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.card-icon i {
    color: white;
    font-size: 16px;
}

.card-content {
    flex: 1;
}

.card-label {
    font-size: 13px;
    color: #6c757d;
    margin-bottom: 4px;
    font-weight: 500;
}

.card-value {
    font-size: 16px;
    font-weight: 600;
    color: #2c3e50;
}

.date-highlight {
    color: #f8981d !important;
}

/* Status badges pequenos */
.status-badge-small {
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.status-pending {
    background-color: #8B00C7;
    color: #ffffff;
}

.status-approved {
    background-color: #FE8D18;
    color: #ffffff;
}

.status-canceled {
    background-color: #DC3545;
    color: #ffffff;
}

.status-progress {
    background-color: #FFA500;
    color: #ffffff;
}

.status-completed {
    background-color: #000000;
    color: #ffffff;
}

.status-unknown {
    background-color: #6c757d;
    color: #ffffff;
}

/* Seções de texto */
.text-sections {
    margin-top: 20px;
}

.text-section {
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 16px;
    border-left: 4px solid #f8981d;
    margin-bottom: 15px;
    height: 100%;
}

.section-header-reserve {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    color: #495057;
    margin-bottom: 10px;
    font-size: 14px;
}

.section-header-reserve i {
    color: #f8981d;
    width: 16px;
}

.section-content {
    color: #2c3e50;
    line-height: 1.5;
    font-size: 14px;
    background-color: white;
    padding: 12px;
    border-radius: 6px;
    border: 1px solid #e2e8f0;
    min-height: 80px;
}

/* Ações de checklist */
.checklist-actions {
    background-color: white;
}

.action-buttons {
    display: flex;
    justify-content: center;
    padding: 20px;
}

.action-buttons .btn {
    min-width: 200px;
}

/* Responsividade */
@media (max-width: 768px) {
    .reservation-details-content {
        padding: 15px;
    }

    .info-cards-grid {
        grid-template-columns: 1fr;
        gap: 10px;
    }

    .info-card {
        padding: 12px;
    }

    .card-icon {
        width: 35px;
        height: 35px;
    }

    .card-icon i {
        font-size: 14px;
    }

    .card-value {
        font-size: 14px;
    }
}

@media (max-width: 576px) {
    .text-section {
        padding: 12px;
    }

    .section-content {
        padding: 10px;
        font-size: 13px;
        min-height: 60px;
    }

    .action-buttons .btn {
        width: 100%;
        min-width: auto;
    }
}

/* Seção de Passageiros */
.passengers-section {
    background-color: white;
}

.passengers-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 15px;
    padding: 20px;
}

.passenger-card {
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 16px;
    border-left: 4px solid #f8981d;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: flex-start;
    gap: 15px;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.passenger-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.passenger-number {
    width: 32px;
    height: 32px;
    background-color: #f8981d;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 14px;
    flex-shrink: 0;
}

.passenger-info {
    flex: 1;
}

.passenger-name {
    font-size: 16px;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
}

.passenger-name i {
    color: #6c757d;
    font-size: 14px;
}

.passenger-status {
    margin-bottom: 6px;
}

.ride-status-badge {
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    display: inline-block;
}

.ride-pending {
    background-color: #ffc107;
    color: #856404;
}

.ride-confirmed {
    background-color: #28a745;
    color: #ffffff;
}

.ride-rejected {
    background-color: #dc3545;
    color: #ffffff;
}

.ride-unknown {
    background-color: #6c757d;
    color: #ffffff;
}

.passenger-date {
    font-size: 13px;
    color: #6c757d;
    margin-top: 4px;
}

.passenger-date i {
    font-size: 12px;
}

/* Responsividade para cards de passageiros */
@media (max-width: 768px) {
    .passengers-grid {
        grid-template-columns: 1fr;
        padding: 15px;
    }

    .passenger-card {
        padding: 12px;
    }

    .passenger-name {
        font-size: 14px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ReserveVehicles/view-components/ViewDataReserve.vue